import React, { useState } from "react";
import { useCallback } from "react";
import { useStores } from "../../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { FormButton } from "../../../components/FormButton";

import { Box, Flex, WrapItem, Avatar, useToast } from "@chakra-ui/react";
import { UserProfileForm } from "../../../components/UserProfileForm";
import { PrimayButton } from "../../../components/Button";

export const TabClient: React.FC = observer(() => {
  const { clientsStore } = useStores();
  const [isEditable, setIsEditable] = useState(false);
  const toast = useToast();
  const { t } = useTranslation();

  const handleEnableEdit = useCallback(() => setIsEditable(true), []);

  const handleSubmit = useCallback(
    (data) => {
      try {
        if (clientsStore.customerData) {
          clientsStore.updateCustomer(clientsStore.customerData.id, data);
          toast({
            status: "success",
            title: t("common.actionExecutedSuccessfully"),
          });
          setIsEditable(false);
        }
      } catch (err) {
        console.log(err);
        toast({
          status: "error",
          title: t("common.error"),
        });
      }
    },
    [clientsStore, t, toast]
  );

  return (
    <Flex mb={"20px"} direction="column">
      {clientsStore.customerData && (
        <Flex direction="row">
          <Box w="20%" p="4">
            <WrapItem>
              <Avatar
                size="2xl"
                name={clientsStore.customerData?.name}
                src={clientsStore.customerData?.picture}
              />
            </WrapItem>
          </Box>
          <Box w="80%" p="4">
            <UserProfileForm
              user={clientsStore.customerData}
              onSubmit={handleSubmit}
              isSubmitting={false}
              editable={isEditable}
              validable={false}
              isAdmin
            />

            {!isEditable && (
              <PrimayButton
                marginTop={"1rem"}
                w={"100%"}
                onClick={handleEnableEdit}
              >
                {t("screens.client.editClient")}
              </PrimayButton>
            )}
          </Box>
        </Flex>
      )}
    </Flex>
  );
});
